import {createSlice} from '@reduxjs/toolkit';

const defaultSeo = {
    title: 'Единый портал медицинских учреждений Нижегородской области',
    description: 'Делитесь мнением о медицинских учреждениях Нижегородской области. Актуальные новости в сфере здравоохранения.'
};

const seoSclice = createSlice({
    name: 'profile',
    initialState: defaultSeo,
    reducers: {
        deleteSeo: (state) => {
            state.title = defaultSeo.title;
            state.description = defaultSeo.description;
        },

        setTitle: (state, action) => {
            state.title = action.payload
        },
        deleteTitle: (state) => {
            state.title = defaultSeo.title;
        },

        setDescription: (state, action) => {
            state.description = action.payload
        },
        deleteDescription: (state) => {
            state.description = defaultSeo.description;
        },
    },
});

export const { 
    setSeo, deleteSeo,
    setTitle, deleteTitle,
    setDescription, deleteDescription
} = seoSclice.actions
export default seoSclice.reducer;